import es from '@/i18n/es.json'
import fr from '@/i18n/fr.json'
import en from '@/i18n/en.json'
import it from '@/i18n/it.json'

export default {
    es: es,
    fr: fr,
    en: en,
    it: it
}



// WEBPACK FOOTER //
// ./src/services/traductions.js